import { FC } from 'react';
import { Image, StyleSheet, Text } from 'react-native';
import { View } from 'react-native';
import { FONTS } from '../../../constants';
import { STYLE_VARS } from '../../../constants/style-vars';

interface ContactMultiItemProps {
  title: string;
  items: {
    icon: any;
    content: string;
  }[];
}

const ContactMultiItem: FC<ContactMultiItemProps> = ({ title, items }) => {
  return (
    <View style={{ marginBottom: 20 }}>
      <View style={{ width: '60%' }}>
        <View>
          <Text style={styles.titleText}>{title}</Text>
          {items.map((item, index) => (
            <View style={{ flexDirection: 'row' }} key={index}>
              <Image source={item.icon} style={styles.icon} />
              <Text style={styles.contentText}>{item.content}</Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

export default ContactMultiItem;

const styles = StyleSheet.create({
  titleText: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 15,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    marginBottom: 5,
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: 7,
    tintColor: STYLE_VARS.primaryColor,
  },
  contentText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 12,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    marginBottom: 5,
  },
});
